import React from 'react'
import {PropTypes} from 'prop-types'
const Spinner = ({size}) => {
	return (
		<div style={{width:`${size+size/4}rem`,height:`${size+size/4}rem`}} className='lds-ring'>
			<div style={{width:`${size}rem`,height:`${size}rem`,borderWidth:`${size/8}rem`,margin:`${size/8}rem`}}/>
			<div style={{width:`${size}rem`,height:`${size}rem`,borderWidth:`${size/8}rem`,margin:`${size/8}rem`}}/>
			<div style={{width:`${size}rem`,height:`${size}rem`,borderWidth:`${size/8}rem`,margin:`${size/8}rem`}}/>
			<div style={{width:`${size}rem`,height:`${size}rem`,borderWidth:`${size/8}rem`,margin:`${size/8}rem`}}/>
		</div>
	)
}
Spinner.propTypes = {
	size: PropTypes.number,
}
export default Spinner
